import React from 'react';
import { isRichContentEmpty } from 'ricos-content';
const getInitialFormState = (content) => ({
    content,
    isEmpty: content && 'nodes' in content ? isRichContentEmpty(content) : true,
    isBusy: false,
    editorKey: Date.now(),
});
export const useContentForm = ({ initialContent, onTyping, }) => {
    const [state, setState] = React.useState(getInitialFormState(initialContent));
    return {
        ...state,
        onChange: (props) => {
            setState((prevState) => {
                if (state.editorKey !== prevState.editorKey) {
                    // In some cases editor calls 'onChange' even after it already should be remounted
                    return prevState;
                }
                if (onTyping && !props.contentTraits.isEmpty) {
                    props.contentTraits.isContentChanged && onTyping();
                }
                return {
                    ...prevState,
                    content: props.content,
                    isEmpty: props.contentTraits.isEmpty,
                    editorKey: prevState.editorKey,
                };
            });
        },
        onBusyChange: (isBusy) => {
            setState((prevState) => {
                if (state.editorKey !== prevState.editorKey) {
                    return prevState;
                }
                return {
                    ...prevState,
                    isBusy,
                    editorKey: prevState.editorKey,
                };
            });
        },
        reset: () => setState(getInitialFormState()),
        getIsValid: () => !state.isBusy && !state.isEmpty,
        getIsEmpty: () => state.isEmpty,
    };
};
//# sourceMappingURL=use-content-form.js.map